import * as React from 'react'
import callResourceAndDispatchActions from '../callResourceAndDispatchActions'
import resetResource from '../resetResource'
import { AppContext } from 'context/appContext'
import { fileTypesGet } from 'lib/files'
import { getToken } from 'utils/auth'
import { getApiCallSequenceSteps as types } from '../../utils/misc'

export const useFileTypesGet = () => {
  const { dispatch } = React.useContext(AppContext)
  const RESOURCE_NAME_FOR_ACTIONS = 'FILE_TYPES_GET'
  const dispatchApiCallActions = () =>
    callResourceAndDispatchActions(fileTypesGet, {
      dispatch,
      token: getToken(),
      types: { ...types(RESOURCE_NAME_FOR_ACTIONS) }
    })
  const dispatchResetAction = () => resetResource(dispatch, { ...types(RESOURCE_NAME_FOR_ACTIONS) })
  return {
    fileTypesGet: dispatchApiCallActions,
    fileTypesGetReset: dispatchResetAction
  }
}
